import { Injectable, signal, WritableSignal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import { URLS_CONST } from 'src/app/shared/constants/url-constants';
import { FileUploadService } from '../file-upload/file-upload.service';
import { Observable, throwError } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class FeedsService {
  showFeedDetails = signal<Boolean>(false)
  totalProjectList: any = []
  constructor(public _utilsService: UtilsService, private _fileUpload: FileUploadService) { }

  get isFeedDetailsVisible() {
    return this.showFeedDetails
  }

  getFeedDetails(feed_id: string) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.feedDetailsV4);
    const params: any = {}
    params[URLS_CONST.FEED_ID] = feed_id
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))
  }

  // getting history
  getHistory(reqParams: any) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.feedDetailsHistory);
    const params: any = reqParams
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))
  }

  searchMangers(params: any) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.searchManagers);
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))
  }

  getManagerSearchUri() {
    return this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.searchManagers);
  }

  getRoleBasedSerchUri() {
    return this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.searchRoleBased);
  }

  getRoleBasedManagers(params: any) {
    let url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.searchRoleBased)
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))
  }
  
  getFeedAndUserfilter(params: any, search_type?: string) {
    let url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.searchFeed);
    if (search_type && search_type == 'user') {
      url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.searchUser);
    }
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))
  }

  getCategoryList(params: any) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.categoryList);
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))

  }

  getFieldDefinitions(params: any) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.getFieldDefinitions);
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))

  }
   getFeedCountByprojectForAccountLevel(params: any) {
    let url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/accounts/response_summary');
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))
  }
  getUiRuleStatus(params: any) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.getUiRuleStatus);
    return this._utilsService.postAPICall(url, params, this._utilsService.setHeaders())
  }
  // chat-conversation
  commentOnFeed(reqBody: any) {
    try {
      const reqData = {
        feed_id: reqBody.feedId,
        is_user_app: reqBody.isCustomerReply,
        comment_text: reqBody.comment,
        attachments: reqBody.attachments,
        is_social: reqBody.isSocial,
        user_id: reqBody.params.user_id,
        update_source: "ltms_dashboard",
        is_internal: reqBody.params.is_internal
      }
      const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.comment);
      return this._utilsService.postAPICall(url, reqData, this._utilsService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred in commentOnFeed:', error);
      return throwError('An unexpected error occurred in commentOnFeed');
    }

  }
  uploadFilesInS3(fileDetails: any, brandId: string) {
    const temp = fileDetails.type && fileDetails.type.trim().length ? fileDetails.type : fileDetails['type-one'];
    const splitFileType = temp.split('/');
    const formData = new FormData();
    formData.append("file", fileDetails);
    formData.append("file_type", splitFileType[0]);
    formData.append("brand_id", brandId);
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.multimediaFilesUpload);
    return this._utilsService.postAPICall(url, formData, this._utilsService.setHeaders())
  }

  getStatusList(params: any) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.brandsStatusListV2);
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))
  }

  getIssueDetailComponentsList(brandId: any, issueId: any) {
    const params = {
      brand_id: brandId,
      issue_id: issueId
    }
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.getDetailComponentList);
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))

  }

  // Helper functions -will be created a saperate file   
  /**
  * Checks if a user has access to a specific feature based on their roles and permissions.
  * @param feature The feature to check access for.
  * @param accessList The list of access permissions for the user.
  * @param issueDetail Details related to the issue or feed being accessed.
  * @param brandDetail Details related to the brand being accessed.
  * @returns true if access is granted, false otherwise.
  */
  checkAccessByFeature(
    feature: string,
    accessList: any[],
    issueDetail: any,
    brandDetail: any
  ): boolean {
    let isAccountMgr = false;
    let isBrandMgr = false;
    let isStoreMgr = false;
    let isGroupMgr = false;
    let allowedForBrand = false;
    let allowedForShop = false;
    let allowedForGroup = false;
    const store = issueDetail?.shops[0] || {};
    const groups = store?.groups || [];
    const feed = issueDetail?.feed;

    if (accessList && accessList.length) {
      accessList.forEach(acs => {
        if (acs.has_dashboard_access) {
          if (acs.brand_id && acs.brand_id.toString() === feed.brand_id.toString() && acs.manager_type === 2) {
            isBrandMgr = true;
            allowedForBrand = feature in acs ? acs[feature] : true;
          } else if (acs.account_id && acs.account_id.toString() === brandDetail.account_id.toString() && acs.manager_type === 3) {
            isAccountMgr = true;
          } else if (acs.shop_id && acs.shop_id.toString() === feed.feed_target_id.toString() && acs.manager_type === 1) {
            isStoreMgr = true;
            allowedForShop = feature in acs ? acs[feature] : true;
          } else if (acs.group_id && groups.length && groups.includes(acs.group_id) && acs.manager_type === 7) {
            isGroupMgr = true;
            allowedForGroup = feature in acs ? acs[feature] : true;
          }
        }
      });
    }

    if (isAccountMgr) {
      return true;
    } else if (isBrandMgr) {
      return allowedForBrand;
    } else if (isGroupMgr) {
      return allowedForGroup;
    } else if (isStoreMgr) {
      return allowedForShop;
    } else {
      return false;
    }
  }


  // Returns the value of a nested property in an object.
  getProp(obj: any, str: string): any {
    str = str.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    str = str.replace(/^\./, ''); // strip a leading dot
    const a = str.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (obj && typeof obj === 'object') {
        if (k in obj) {
          obj = obj[k];
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    }
    return obj;
  }

  // Converts an array of objects into a Map for efficient lookup.
  // return a  Map is keyed by the specified property of each object.
  prepareMap = function (arrOfObj, id) {
    var lwMap = new Map();
    if (arrOfObj && arrOfObj.length) {
      _.each(arrOfObj, function (obj) {
        if (obj && obj[id]) {
          lwMap.set(obj[id], obj);
        }
      })
    }
    return lwMap;
  }

  hasProperty = function (obj, keys) {
    return keys.split(".").every(function (key) {
      if (typeof obj != "object" || obj === null || !(key in obj)) {
        return false;
      }
      obj = obj[key];
      return true;
    });
  }


  // Creates a deep copy of a given object.
  deepClone = function (obj) {
    if (obj)
      return JSON.parse(JSON.stringify(obj));
  }

  createNote(params: any) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.createNote);
    return this._utilsService.postAPICall(url, params, this._utilsService.setHeaders())
  }

  updateCustomParameter(feedId: string, params: any) {
    let parameters: any = {
      tag_type: 7,
      lw_custom_field: params["customFeed"],
      update_source: "ltms_dashboard"
    }
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.updateCustomParameter);
    return this._utilsService.putAPICall(url, parameters, this._utilsService.setHeaderWithParams({ feed_id: feedId }))
  }

  assignUserToFeed(feedId: string, manager: any, isRemoveAssignee: boolean, tagType?: number, isRoleBased?: boolean, managerLevelDetail?: any, brandId?: string) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.updateCustomParameter);
    if (manager) {
      var params = {
        "tag_type": (tagType) ? tagType : 4,
        "update_source": "ltms_dashboard"

      }
      if (tagType == 8) {
        params["is_remove_follower"] = isRemoveAssignee || false;
        if (isRoleBased) {
          params["roles_followed_by"] = managerLevelDetail;
        } else {
          params["followers_id_list"] = manager;
        }
      } else if (!isRoleBased) {
        params["is_remove_assignee"] = isRemoveAssignee || false;
        params["assigned_to_id_list"] = manager;
      } else {
        params["is_remove_assignee"] = isRemoveAssignee || false;
        params["role_assigned_level_detail"] = managerLevelDetail;
        params["is_role_based"] = isRoleBased;
        params["brand_id"] = brandId;
      }
      return this._utilsService.putAPICall(url, params, this._utilsService.setHeaderWithParams({ feed_id: feedId }))
    } else {
      return new Observable((subscriber) => {
        subscriber.next(null)
      })
    }
  }

  assignTagsToFeed(feedId, tagType, idList, tagName) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.updateCustomParameter)
    const params: any = {
      tag_type: tagType,
      status_id_list: (tagType === 1) ? idList : null,
      category_id_list: (tagType === 2) ? idList : null,
      tag_id_list: (tagType === 3 && !tagName) ? idList : null,
      tag_name: (tagName) ? tagName : null,
      update_source: "ltms_dashboard"
    }
    return this._utilsService.putAPICall(url, params, this._utilsService.setHeaderWithParams({ feed_id: feedId }))

  }

  markFeedAsUnread(feedId: string, brandId: string) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.feedEvent);
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams({
      fid: feedId,
      eid: "unread",
      brand_id: brandId,
      entity_type: 1
    }))
  }

  getFeedsByFilter(feedfilters) {
    var filters = Helpers.deepClone(feedfilters)
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.feedListV3);

    const body = {
      shop_id_list: filters.shopIds,
      primary_rating_levels: filters.primaryRatingLevels,
      // If not from ES then pass status ID
      status_id_list: (filters.dataSource != 2) ? filters.statusIds : [],
      category_id_list: (filters.dataSource != 2) ? filters.categoryIds : [],
      tag_id_list: (filters.dataSource != 2) ? filters.tagIds : [],
      // If dataSource is (2)ES or undefined then only universal filters will be passed
      // universal_filter: (filters.dataSource != 1) ? Utils.getProp(Helpers, "universalFilter") : null, //(!_.isEmpty(Helpers.universalFilter)) ? Helpers.universalFilter : null, 
      universal_filter: (filters.dataSource != 1) ? filters.universalFilter : null,
      assigned_to_id_list: filters.assignedToIds || null,
      followers_id_list: filters.followerIds || null,
      role_assigned_to: filters.roleAssignedTo || [],
      roles_followed_by: filters.rolesFollowedBy || [],
      non_existant_fields: filters.nonExistantFields || null,
      considered_closed_status: filters.consideredClosedStatus || null,
      tat_hours: filters.TAThours || null,
      actionable_ratings: filters.actionableRatings || null,
      age_type: filters.age_type || null,
      tat_status_list: filters.tatStatusClosed || null,
      account_id: filters.accountId,
      brand_id: filters.brandId,
      group_id: filters.groupId,
      shop_id: filters.shopId,
      from: filters.from,
      to: filters.to,
      limit: filters.limit,
      is_publish: filters.isPublish,
      comment_keyword: filters.commentKeyword,
      comment_keyword_switch: filters.commentKeywordSwitch,
      empty_comments_filter: filters.emptyCommentsFilter,
      include_excluded_feeds: filters.includeExcludedFeeds,
      date_filter_type: filters.dateFilterType,
      page_number: filters.pageNumber,
      user_id: filters.userId,
      interaction_status: filters.interactionStatus,
      field_id: filters.fieldId,
      search_type: filters.searchType,
      search_text: filters.searchText,
      is_filter_by_history: filters.isFilterByHistory,
      custom_filter_list: filters.customFilterList,
      hierarchy_filter_details_list: filters.hierarchyFilterDetailsList,
      date_sort_order: filters.dataSortOrder,
      text_v2_status: filters.textV2Status,
      data_source: filters.dataSource,
      is_service_management: filters.is_service_management,
      assignee_follower_brand_id: filters.assigneeFollowerBrandId,
      // field_to_sort_on: Only in case of ES
      field_to_sort_on: filters.fieldToSortOn,
      field_sort_order: filters.fieldSortOrder
    }
    const bodyParams = {}
    const queryParams = {};
    _.each(body, (value, key) => {
      if (value) {
        bodyParams[key] = value
      }
    })

    // return this._utilsService.getAPICall(url + "?" + this._utilsService.convertObjectToQueryParams(query), this._utilsService.setHeaderWithParams(bodyParams))
    return this._utilsService.getAPICall(url , this._utilsService.setHeaderWithParams(bodyParams))
  }
  getAccontFeedList(reqBody) {
    try {
      const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.feedList);
      return this._utilsService.postAPICall(url, reqBody, this._utilsService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred in getFeedListPost:', error);
      return throwError('An unexpected error occurred in getFeedListPost');
    }
  }

  mailAdvancedDownloadReport(queryObject) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/feedbacks/response_downloader');
    return this._utilsService.postAPICall(url, queryObject, this._utilsService.setHeaders());
  }


  downloadAttachment(attachment: string, brand_id: string) {
    var file_url = '';
    //download file from mongoDb
    if (attachment) {
      if (attachment != null && typeof attachment === 'string' && attachment.length === 24 && typeof attachment != undefined) {
        file_url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.fileUrl + attachment);
        window.open(file_url, "resizable=yes, left=30, width=1000, height=500");
      } //download file from s3 bucket
      else {
        this._fileUpload.getPublicUrl({
          'brand_id': brand_id,
          'file_url': attachment,
          'type': 1
        }).subscribe((response) => {
          file_url = response.data.file_url;
          var newWin = window.open(file_url, "_blank", "resizable=yes, left=30, width=1000, height=500");
          if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
            Helpers.smallAlertBox("Error", "Pop-up blocked. Please enable pop-ups for this site", "error");
          }
        })
      }
    }
  }

  getADRProgresStatus(param){
    const url= this._utilsService.apiUrlGeneration(environment.webPrivateV1,environment.webPrivateV1.adrStatus);
    return this._utilsService.getAPICall(url,this._utilsService.setHeaderWithParams(param))
  }
}
